export const PATH = '/edition/asset';
